import { render, staticRenderFns } from "./ServerInternalError.vue?vue&type=template&id=58b9fb6d&scoped=true"
import script from "./ServerInternalError.vue?vue&type=script&lang=js"
export * from "./ServerInternalError.vue?vue&type=script&lang=js"
import style0 from "./ServerInternalError.vue?vue&type=style&index=0&id=58b9fb6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b9fb6d",
  null
  
)

export default component.exports